import React from "react";
import { DollarSign, Bitcoin, Boxes, TrendingUp } from "lucide-react";
import { TRADE_PAIR_CATEGORIES } from "../../data/tradePairs";

const CATEGORY_ICONS = {
  currencies: DollarSign,
  crypto: Bitcoin,
  commodities: Boxes,
  stocks: TrendingUp,
};

export function CategoryTabs({ activeCategory, onSelectCategory }) {
  return (
    <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid="trade-pair-categories">
      {TRADE_PAIR_CATEGORIES.map((cat) => {
        const Icon = CATEGORY_ICONS[cat.id] || DollarSign;
        const isActive = activeCategory === cat.id;

        return (
          <button
            key={cat.id}
            onClick={() => onSelectCategory(cat.id)}
            data-testid={`category-tab-${cat.id}`}
            className={`group flex items-center justify-center gap-2.5 rounded-xl border px-4 py-3 font-mono text-xs font-semibold uppercase tracking-wider transition-all ${
              isActive
                ? "border-[#d4d8dc]/50 bg-gradient-to-b from-white/15 to-white/5 text-white shadow-lg ring-1 ring-white/20 font-bold"
                : "border-white/8 bg-white/[0.02] text-neutral-400 hover:border-white/20 hover:bg-white/[0.04] hover:text-neutral-200"
            }`}
          >
            <Icon size={15} className={isActive ? "text-white" : "text-neutral-500 group-hover:text-neutral-300"} />
            <span>{cat.label}</span>
            <span
              className={`ml-1 rounded px-1.5 py-0.5 font-mono text-[10px] tabular-nums ${
                isActive ? "bg-white/20 text-white font-bold" : "bg-white/5 text-neutral-500"
              }`}
            >
              {cat.instruments.length}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default CategoryTabs;
